module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-forgot-password-verify clearfix"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.labels['50']))]), _vm._v(" "), _c('div', {
    staticClass: "box-intro"
  }, [_vm._v("\n    " + _vm._s(_vm.labels['160']) + "\n  ")]), _vm._v(" "), _c('label', {
    staticClass: "box-input-material clearfix"
  }, [_c('div', {
    staticClass: "fa fa-shield icon-id"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otpCode),
      expression: "otpCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'focus': _vm.otpCode != '', 'input-error': _vm.errors.has('otpCode')
    },
    attrs: {
      "name": "otpCode"
    },
    domProps: {
      "value": (_vm.otpCode)
    },
    on: {
      "keyup": function($event) {
        _vm.clearResponse()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otpCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.labels['150']))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('otpCode')),
      expression: "errors.has('otpCode')"
    }],
    staticClass: "login-validate"
  }, [_vm._v(_vm._s(_vm.errors.first('otpCode')))])]), _vm._v(" "), (_vm.loadingDisp) ? _c('div', {
    staticClass: "infinite-loading-container"
  }, [_c('i', {
    staticClass: "loading-wave-dots"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.response !== ''),
      expression: "response !== ''"
    }],
    staticClass: "response-msg"
  }, [_vm._v(_vm._s(_vm.response))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispBtnOk),
      expression: "!dispBtnOk"
    }],
    staticClass: "btn-forgot submit",
    on: {
      "click": function($event) {
        _vm.validateInput()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['120']))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.dispBtnOk),
      expression: "!dispBtnOk"
    }],
    staticClass: "btn-forgot cancel",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['110']))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dispBtnOk),
      expression: "dispBtnOk"
    }],
    staticClass: "btn-change submit",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels['130']))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-733b4fd4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/forgotPasswordVerify.vue
// module id = 3867
// module chunks = 1